import React, { ReactNode } from 'react'
import { Box, BoxProps } from 'transfix-ui/core'

interface ITextInputGroupProps extends BoxProps {
  label?: string
  id?: string
  children: ReactNode
}

// Wrapper around TextInput's grouped together
const TextInputGroup = ({ children, id, label, ...props }: ITextInputGroupProps) => {
  return (
    <Box display='flex' flexDirection='column' {...props}>
      {label && (
        <label className='' htmlFor={id}>
          {label}
        </label>
      )}
      <Box display='flex' alignItems='center' className='text-input-group'>
        {children}
      </Box>
    </Box>
  )
}

export default TextInputGroup
